import axios from 'axios';
import store from '../store';
import NProgress from 'nprogress';

const WHITE_LISTED_PATHS_FROM_GLOBAL_LOADER = ['campaigns/[^/]+/order'];

const HTTP = axios.create({
  baseURL: process.env.VUE_APP_REST_API,
});
let count = 0;
NProgress.configure({easing: 'ease', speed: 20});
HTTP.interceptors.request.use((config) => {
  const isWhiteListed = WHITE_LISTED_PATHS_FROM_GLOBAL_LOADER.some((regex) =>
    new RegExp(regex).test(config.url)
  );

  if (!isWhiteListed) {
    NProgress.start();
    count++;
  }

  const token = localStorage.getItem('token');
  config.headers[process.env.VUE_APP_AUTH_HEADER] = token
    ? `Bearer ${token}`
    : '';
  return config;
});

let responseInterceptor = HTTP.interceptors.response.use(
  (response) => {
    count--;
    if (count <= 0) {
      NProgress.done();
    }
    return response;
  },
  (error) => {
    count--;
    if (count <= 0) {
      NProgress.done();
    }
    let errorResponse = error.response;
    let originalRequest = error.config;
    if (typeof errorResponse !== 'undefined' && errorResponse.status === 401) {
      let refreshedHTTP = axios.create({
        baseURL: process.env.VUE_APP_REST_API,
      });
      return refreshedHTTP
        .post(`token/refresh`, {
          refresh_token: localStorage.getItem('refreshToken'),
        })
        .then((response) => {
          count--;
          if (count <= 0) {
            NProgress.done();
          }
          originalRequest.headers.Authorisation = `Bearer ${
            response.data.token
          }`;
          store.dispatch('setToken', response.data);
          return HTTP(originalRequest)
            .then((result) => {
              count--;
              if (count <= 0) {
                NProgress.done();
              }
              return result;
            })
            .catch((error) => {
              count--;
              if (count <= 0) {
                NProgress.done();
              }
              return Promise.reject(error);
            });
        })
        .catch((error) => {
          count--;
          if (count <= 0) {
            NProgress.done();
          }
          store.dispatch('logout');
          if (
            typeof originalRequest.data == 'undefined' ||
            JSON.parse(originalRequest.data)['function'] != 'login'
          ) {
            window.location.href = '/login?session=timeout';
          }
          return Promise.reject(error);
        });
    }
    if (typeof errorResponse !== 'undefined' && errorResponse.status === 403) {
      NProgress.done();
      store.dispatch('logout');
      window.location.href = '/';
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

export default HTTP;
